import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { LeadForm } from "../components/LeadForm";

const VALUES = [
  { title: "İnsan", desc: "Her öğrenme yolculuğunun merkezinde insan var." },
  { title: "Merak", desc: "Öğrenmeyi başlatan ve canlı tutan güç meraktır." },
  { title: "Anlam", desc: "Bilgiyi anlama ve yaşama bağlamadan dönüşüm olmaz." },
  { title: "Birlikte", desc: "Bilgelik yalnız değil, toplulukla büyür." },
];

export default function Hakkimizda() {
  return (
    <>
      <Seo title="Hakkımızda" description="Bilgece; Türkiye'den doğan, wisdom-based learning & living markası. Vizyonumuz, değerlerimiz ve yolculuğumuz." />
      <section className="relative pt-40 pb-28 grain overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.pexels.com/photos/38696179/pexels-photo-38696179.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-brand-green/88" />
        </div>
        <div className="relative container-narrow px-6 lg:px-10 text-brand-offwhite max-w-3xl">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold-light font-semibold mb-4">Hakkımızda</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light leading-tight">Yaşamı öğrenmenin yolu</h1>
          <p className="text-brand-offwhite/85 text-lg mt-6 leading-relaxed">Bilgece, Türkiye'den doğan ve zamanla uluslararasılaşmayı hedefleyen bir wisdom-based learning &amp; living markasıdır.</p>
        </div>
      </section>

      <section className="section-pad bg-brand-offwhite">
        <div className="container-narrow grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-4xl text-brand-green mb-5">Neden Bilgece?</h2>
            <div className="space-y-5 text-brand-text/75 text-lg leading-relaxed">
              <p>Bilgiye erişim hiç bu kadar kolay olmamıştı. Ancak daha çok bilmek, daha iyi yaşadığımız anlamına gelmiyor. Asıl mesele bilgiyi anlama, deneyime ve bilgece bir yaşama dönüştürebilmek.</p>
              <p>Bilgece; çocuklardan ebeveynlere, öğretmenlerden liderlere uzanan bütünsel bir ekosistem olarak bu dönüşümü mümkün kılmak için var.</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-brand-green text-brand-offwhite rounded-sm p-10">
              <p className="font-serif text-2xl md:text-3xl italic leading-snug">"Daha çok bilmek için değil, daha bilgece yaşamak için."</p>
              <p className="mt-6 text-brand-gold-light tracking-widest text-sm">— BİLGECE™</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section-pad bg-brand-cream">
        <div className="container-narrow">
          <Reveal><h2 className="font-serif text-3xl md:text-5xl text-brand-green mb-12">Değerlerimiz</h2></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="h-full bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-8">
                  <h3 className="font-serif text-2xl text-brand-gold">{v.title}</h3>
                  <p className="text-brand-text/70 text-sm mt-3 leading-relaxed">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad bg-brand-offwhite">
        <div className="container-narrow max-w-2xl">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-green mb-3">Bize ulaşın</h2>
            <p className="text-brand-text/70 mb-8">Bir sorunuz mu var? Aşağıdan bize yazın.</p>
          </Reveal>
          <div className="bg-brand-cream border border-brand-gold-light/40 rounded-sm p-8 md:p-10">
            <LeadForm testid="contact-form" source="contact" fields={["name", "email", "phone", "message"]} submitLabel="Mesaj Gönder" />
          </div>
        </div>
      </section>
    </>
  );
}
